<template>
  <div class="container-page-comparables">
    <div class="page-comparables--col page-comparables--col__left">
      <div class="page-comparables--map">
        <img :src="mapImg" :style="mapImgStyle" alt="">
      </div>
      <div class="page-comparables--table mt-1">
        <div v-if="stockTable !== null" class="valuations_subtitle mb-1">
          <span class="subtitle-1">{{ $t("supply-and-demand") }}</span> <span class="subtitle-2">(Flat)</span>
        </div>
        <table v-if="stockTable !== null" class="brains-table2 brains-table--double-horizontal brains-table2export" aria-describedby="tablenostock2">
          <thead>
            <tr v-if="stockTable.stockDataType === 'bed'">
              <th scope="col" />
              <th scope="col" />
              <th scope="col">1 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">2 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">3 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">4 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">{{ $t("average") }}</th>
            </tr>
            <tr v-else-if="stockTable.stockDataType === 'smallSQM'">
              <th scope="col" />
              <th scope="col" />
              <th scope="col">&#60; 100 {{ $t("sqm") }}</th>
              <th scope="col">100 - 250 {{ $t("sqm") }}</th>
              <th scope="col">250 - 500 {{ $t("sqm") }}</th>
              <th scope="col">&#62; 500 {{ $t("sqm") }}</th>
              <th scope="col">{{ $t("average") }}</th>
            </tr>
            <tr v-else>
              <th scope="col" />
              <th scope="col" />
              <th scope="col">&#60; 500 {{ $t("sqm") }}</th>
              <th scope="col">500 - 1.000 {{ $t("sqm") }}</th>
              <th scope="col">1.000 - 2.500 {{ $t("sqm") }}</th>
              <th scope="col">&#62; 2.500 {{ $t("sqm") }}</th>
              <th scope="col">{{ $t("average") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="stockTable && stockTable.published">
              <td class="brains-table-rowspan" rowspan="2">{{ $t("units2") }}</td>
              <td>{{ $t("supply") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "num_habitaciones", stockTable) }}</td>
              </template>
              <td>{{ getDataNumHabitacionAvgTable("published", stockTable) }}</td>
            </tr>
            <tr v-if="stockTable && stockTable.unpublished">
              <td>{{ $t("demand") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "num_habitaciones", stockTable) }}</td>
              </template>
              <td>{{ getDataNumHabitacionAvgTable("unpublished", stockTable) }}</td>
            </tr>

            <!-- ------------- -->

            <tr v-if="stockTable && stockTable.published">
              <td class="brains-table-rowspan" rowspan="2">%</td>
              <td>{{ $t("supply") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "porcentaje", stockTable) }}%</td>
              </template>
              <td>100%</td>
            </tr>
            <tr v-if="stockTable && stockTable.unpublished">
              <td>{{ $t("demand") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "porcentaje", stockTable) }}%</td>
              </template>
              <td>100%</td>
            </tr>

            <!-- ---------- -->

            <tr v-if="stockTable && stockTable.published">
              <td class="brains-table-rowspan" rowspan="2">
                <span v-if="currentFilter === 'Venta'">{{ $t("marketplace.eur-sqm") }}</span>
                <span v-else>{{ $t("assetData.eur-sqm-mo") }}</span>
              </td>
              <td>{{ $t("supply") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "esqm2", stockTable) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_pub", "esqm2", stockTable) }}</td>
            </tr>
            <tr v-if="stockTable && stockTable.unpublished">
              <td>{{ $t("demand") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "esqm2", stockTable) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "esqm2", stockTable) }}</td>
            </tr>
            <!-- ------------------ -->

            <tr v-if="stockTable && stockTable.published">
              <td class="brains-table-rowspan" rowspan="2">
                <span v-if="currentFilter === 'Venta'">€</span>
                <span v-else>{{ $t("assetData.eur-month") }}</span>
              </td>
              <td>{{ $t("supply") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "euro", stockTable) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_pub", "euro", stockTable) }}</td>
            </tr>
            <tr v-if="stockTable && stockTable.unpublished">
              <td>{{ $t("demand") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "euro", stockTable) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "euro", stockTable) }}</td>
            </tr>
            <!-- --------------------- -->

            <tr v-if="stockTable && stockTable.published">
              <td class="brains-table-rowspan" rowspan="2">{{ $t("valuationFilters.sqm") }}</td>
              <td>{{ $t("supply") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "sqm", stockTable) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_pub", "sqm", stockTable) }}</td>
            </tr>
            <tr v-if="stockTable && stockTable.unpublished">
              <td>{{ $t("demand") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "sqm", stockTable) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "sqm", stockTable) }}</td>
            </tr>
            <!-- ------------------ -->

            <tr v-if="stockTable && stockTable.unpublished">
              <td class="ff-semibold" rowspan="2">{{ $t("dataSelectors.published-time") }}</td>
              <td rowspan="2">{{ $t("demand") }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "published_time", stockTable) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "published_time", stockTable) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="page-comparables--col page-comparables--col__right">
      <div class="page-comparables--table-comps comparablelist-page-export">
        <table class="comparables_table" aria-describedby="tablecompds">
          <thead>
            <tr>
              <th>
                {{ $t("type") }}
              </th>
              <th>
                {{ $t("valuationFilters.dist") }}
              </th>
              <th>
                {{ $t("assetData.address") }}
              </th>
              <th>
                {{ $t("valuationFilters.sqm") }}
              </th>
              <th>{{ $t("price") }} (€)</th>
              <th>
                {{ $t("marketplace.eur-sqm") }}
              </th>
              <th class="cursor-default">Evo.</th>
              <th>
                <div class="svg-icon-comps">
                  <img :src="bed" class="tableicon" alt="img">
                </div>
              </th>
              <th>
                {{ $t("valuationFilters.on-brains") }}
              </th>
            </tr>
          </thead>
          <tbody id="selectedcomparables_table">
            <tr
              v-for="comparable in comparables.selectedcomparables"
              :id="'comparable-' + comparable.iD_comparable"
              :key="comparable.iD_comparable + '_selected'"
              class="selectedrow"
              :class="getComparablesClass(true, comparable)"
            >
              <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="img"></td>
              <td>21</td>
              <td class="comparables_adress">
                <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                  <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                  <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                  <span v-else>na</span>
                </a>
                <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </td>
              <td>{{ formatterSqm(comparable.c_superficie) }}</td>
              <td>{{ formatterPrice(comparable.c_precio) }}</td>
              <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
              <td>
                <span v-if="comparable.c_inc_precio12 < 0"><img :src="down" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else-if="comparable.c_inc_precio12 > 0"><img :src="up" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else><img :src="equal" class="tableicon" width="10" height="11" alt="img"></span>
              </td>
              <td>{{ comparable.c_habitaciones }}</td>
              <td class="txt-center">{{ formatterTime(comparable.pubdays) }}</td>
            </tr>
          </tbody>
          <tbody id="comparableslist_table">
            <tr
              v-for="comparable in comparables.currentComparables"
              :id="'comparable-' + comparable.iD_comparable"
              :key="comparable.iD_comparable"
              :class="getComparablesClass(false, comparable)"
            >
              <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="img"></td>
              <td>{{ formatterDist(comparable.c_dist) }}</td>
              <td class="comparables_adress">
                <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                  <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                  <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                  <span v-else>na</span>
                </a>
                <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </td>
              <td>{{ formatterSqm(comparable.c_superficie) }}</td>
              <td>{{ formatterPrice(comparable.c_precio) }}</td>
              <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
              <td>
                <span v-if="comparable.c_inc_precio12 < 0"><img :src="down" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else-if="comparable.c_inc_precio12 > 0"><img :src="up" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else><img :src="equal" class="tableicon" width="10" height="11" alt="img"></span>
              </td>
              <td>{{ comparable.c_habitaciones }}</td>
              <td class="txt-center">{{ formatterTime(comparable.pubdays) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
import bed from '@/assets/brains_icons/bed.svg'
import down from '@/assets/brains_icons/down.png'
import up from '@/assets/brains_icons/up.png'
import equal from '@/assets/brains_icons/equal.png'
import { _ } from 'vue-underscore'

export default {
  name: 'PageComparables',
  components: {},
  props: {
    comparables: {
      type: Object,
      default: null
    },
    mapImg: {
      default: null
    },
    stockTable: {
      default: null
    }
  },
  data() {
    return {
      nhab: [1, 2, 3, 4],
      bed: bed,
      down: down,
      up: up,
      equal: equal,
      currentFilter: 'Venta',
      mapImgWidthStyle: null,
      mapImgHeightStyle: null,
      mapImgStyle: null
    }
  },
  computed: {},
  mounted: function() {
    setTimeout(() => {
      this.setMapImgData()
    }, 500)
  },
  methods: {
    // Se posiciona la imagen de tal forma que no se descoloque en otras resoluciones
    setMapImgData() {
      this.mapImgWidthStyle = document.querySelector('.page-comparables--map img').clientWidth / 2
      this.mapImgHeightStyle = document.querySelector('.page-comparables--map img').clientHeight / 2
      this.mapImgStyle = 'left: calc(50% - ' + this.mapImgWidthStyle + 'px); top: calc(50% - ' + this.mapImgHeightStyle + 'px)'
    },
    formatterTypology(idtipo) {
      switch (idtipo) {
        case 0:
          return require('@/assets/brains_icons/residential.png')
        case 1:
          return require('@/assets/brains_icons/flatblack.png')
        case 2:
          return require('@/assets/brains_icons/house.png')
        case 3:
          return require('@/assets/brains_icons/parking.png')
        case 4:
          return require('@/assets/brains_icons/storage.png')
        case 5:
          return require('@/assets/brains_icons/land.png')
        case 6:
          return require('@/assets/brains_icons/retail.png')
        case 7:
          return require('@/assets/brains_icons/office.png')
        case 8:
          return require('@/assets/brains_icons/building.png')
        case 9:
          return require('@/assets/brains_icons/hospitality.png')
        case 10:
          return require('@/assets/brains_icons/industrial.png')
        case 11:
          return require('@/assets/brains_icons/other.png')
        default:
          return require('@/assets/brains_icons/other.png')
      }
    },
    getComparablesClass(selected, comparable) {
      if (selected) {
        return comparable.c_categoria === 'Publicados' ? 'comparable_pub_selected' : 'comparable_nopub_selected'
      }
      return comparable.c_categoria === 'Publicados' ? 'comparable_pub' : 'comparable_nopub'
    },
    formatterDate(itm) {
      return itm !== null ? this.$moment(itm).format('MM/YYYY') : ''
    },
    formatterPrice(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0,0 $') : ''
    },
    formatterEurSqm(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0,0 $') : ''
    },
    formatterDist(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0') : ''
    },
    formatterSqm(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0') : ''
    },
    formatterTime(itm) {
      return itm !== null ? numeral(itm).format('0') + ' d' : ''
    },
    getDataHabitacionTable(n, type, unit, table) {
      var result = _.filter(table[type], function(item) {
        return item.habitaciones === n
      })
      if (result.length > 0) {
        result = result[0][unit]
      } else {
        result = '-'
      }
      if (result === null || result === undefined) {
        result = '-'
      } else {
        if (unit === 'porcentaje' || unit === 'published_time') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        } else if (this.currentFilter === 'Alquiler' && unit === 'esqm2') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
        } else {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        }
      }
      return result
    },
    getDataHabitacionAvgTable(type, unit, table) {
      var result = table[type]
      if (result !== null && result !== undefined && result[unit] !== null && result[unit] !== undefined && result[unit] !== 'NaN') {
        result = result[unit]
      } else {
        result = '-'
      }
      if (result === null || result === undefined) {
        result = '-'
      } else {
        if (unit === 'porcentaje' || unit === 'published_time') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        } else if (this.currentFilter === 'Alquiler' && unit === 'esqm2') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
        } else {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        }
      }
      return result
    },
    getDataNumHabitacionAvgTable(type, table) {
      var result = 0

      if (table !== null && table !== undefined) {
        table[type].forEach((item) => {
          if (item.num_habitaciones !== null) {
            result += item.num_habitaciones
          }
        })
      }

      if (result === 0) {
        result = '-'
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.container-page-comparables {
  width: 100%;
  height: 100%;
  display: grid;

  grid-template-columns: 49% 49%;
  gap: 20px;
  justify-content: space-between;

  .page-comparables--col__left {
    display: grid;

    grid-template-rows: 46% 54%;
    grid-template-columns: 1fr;
    justify-content: space-between;

    .page-comparables--table {
      font-size: 12px;
    }
  }

  .page-comparables--col {
    .page-comparables--fotos {
      display: flex;
      justify-content: space-between;
      width: 100%;

      img {
        width: 48%;
      }
    }

    .page-comparables--map {
      overflow: hidden;
      position: relative;
      max-height: 321px;
      img {
        position: absolute;
        top: -285px;
        left: -140px;
      }
    }
  }
}

.comparablelist-page-export table {
  width: 100%;
  font-size: 11px;
  border-spacing: 0;

  thead {
    th {
      padding: 4px;
      background-color: white;
      border-bottom: 2px solid #1e3cff;
      font-family: "Montserrat-ExtraBold",sans-serif;
    }

    th:nth-child(1),
    th:nth-child(2),
    th:nth-child(7) {
      text-align: center;
    }

    th:nth-child(4),
    th:nth-child(5),
    th:nth-child(6),
    th:nth-child(8) {
      text-align: right;
    }
  }

  tbody {
    tr {
      height: 12px;
    }

    td {
      height: 12px;
      border-bottom: none;
    }

    td:nth-child(1),
    td:nth-child(2),
    td:nth-child(7) {
      text-align: center;

      img {
        vertical-align: middle;
      }
    }

    td:nth-child(4),
    td:nth-child(5),
    td:nth-child(6),
    td:nth-child(9) {
      text-align: right;
    }

    td:nth-child(8) {
      text-align: center;
    }

    .comparable_pub_selected {
      background-color: rgb(216,175,70);

      &:hover {
        cursor: pointer;
        background-color: rgba(216,175,70, 0.596);
      }
    }

    .comparable_nopub_selected {
      background-color: rgb(194,194,194);

      &:hover {
        background-color: rgba(194,194,194, 0.425);
      }
    }

    .comparable_pub {
      background-color: rgb(232,210,128);

      &:hover {
        cursor: pointer;
        background-color: rgba(232,210,128, 0.548);
      }
    }

    .comparable_nopub {
      background-color: rgb(240,240,240);

      &:hover {
        background-color: rgba(240,240,240, 0.349);
      }
    }
  }

  .comparables_adress {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 130px;

    a {
      text-decoration: underline !important;
    }
  }
}

.comparablelist-page-export {
  height: 100%;
  font-family: "Montserrat-Regular",sans-serif;
}

.svg-icon {
  width: 25px !important;
  height: 15px !important;
  vertical-align: inherit !important;
}

.valuations_subtitle {
  margin-bottom: 3px;
  font-size: 15px;

  .subtitle-1 {
    font-family: "Montserrat-SemiBold",sans-serif;
  }

  .subtitle-2 {
    font-family: "Montserrat-Light",sans-serif !important;
  }

  .valuations_subtitle_small {
    font-weight: normal;
    font-family: "Montserrat-Regular",sans-serif;
    font-size: 0.8em;
  }
}

.ff-semibold {
  font-family: "Montserrat-SemiBold",sans-serif;
}

.svg-icon-comps {
  text-align: center;
}

</style>
